import { render, staticRenderFns } from "./setting-form.vue?vue&type=template&id=3206d83e&scoped=true&"
import script from "./setting-form.vue?vue&type=script&lang=js&"
export * from "./setting-form.vue?vue&type=script&lang=js&"
import style0 from "./setting-form.vue?vue&type=style&index=0&id=3206d83e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3206d83e",
  null
  
)

export default component.exports